import React, { useEffect, useState } from "react";
import { getButtonValuesAPI } from "../service/AuthService";

export default function BetSlip({
  selectedEventForBet,
  setSelectedEventForBet,
  dispatch,
  placeBet,
  isFancy,
}) {
  const [buttons, setButtons] = React.useState({});

  const getButtonValues = async () => {
    const { response } = await getButtonValuesAPI();
    setButtons(response);
  };

  useEffect(() => {
    getButtonValues();
  }, []);
  if (selectedEventForBet?.isCashout) return null;
  return (
    <tr _ngcontent-ng-c1546520345="">
      <td
        _ngcontent-ng-c1546520345=""
        colspan="7"
        class={`custom-td ${
          selectedEventForBet?.type == "back" ? "blue" : "pink"
        }-bet-slip-back`}
        id="betslip11056084_402024910195834877"
      >
        <div _ngcontent-ng-c1546520345="" _nghost-ng-c1814318807="">
          <div _ngcontent-ng-c1814318807="" className="fancy-quick-tr placebet">
            <div
              _ngcontent-ng-c1814318807=""
              className={`place-bet slip-${selectedEventForBet?.type}`}
            >
              <div _ngcontent-ng-c1814318807="" className="container">
                <div
                  _ngcontent-ng-c1814318807=""
                  className="row ps-2 pe-2 pb-0 padddingZero"
                >
                  <div
                    _ngcontent-ng-c1814318807=""
                    className="col p-1 pb-0 hideMobile"
                  >
                    <a
                      onClick={() => {
                        setSelectedEventForBet(null);
                      }}
                      _ngcontent-ng-c1814318807=""
                      className="btn btn-secondary btn-block btn-cancel"
                    >
                      {" "}
                      Cancel{" "}
                    </a>
                  </div>
                  <div
                    _ngcontent-ng-c1814318807=""
                    className="col text-left p-1 stacksCol"
                  >
                    <button
                      _ngcontent-ng-c1814318807=""
                      onClick={() => {
                        if (selectedEventForBet?.selectedOdd < 0.01) return;
                        setSelectedEventForBet({
                          ...selectedEventForBet,
                          selectedOdd: parseFloat(
                            parseFloat(selectedEventForBet?.selectedOdd) - 0.01
                          ).toFixed(2),
                        });
                      }}
                      className="stakeactionminus btn betButtonMinus"
                    >
                      <span
                        _ngcontent-ng-c1814318807=""
                        className="betButtonMinus"
                      >
                        <svg
                          _ngcontent-ng-c1814318807=""
                          version="1.1"
                          id="Layer_1"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                          x="0px"
                          y="0px"
                          width="19px"
                          height="19px"
                          viewBox="0 0 19 19"
                          enableBackground="new 0 0 19 19"
                          xmlSpace="preserve"
                        >
                          <g _ngcontent-ng-c1814318807="">
                            <path
                              _ngcontent-ng-c1814318807=""
                              fill="currentColor"
                              d="M8.056,10.838H0.409V8.091h7.647 M2,8.091h16.591v2.747H8"
                            />
                          </g>
                        </svg>
                      </span>
                    </button>
                    {console.log(selectedEventForBet)}
                    <input
                      style={isFancy ? { width: "81% " } : {}}
                      disabled={true}
                      _ngcontent-ng-c1814318807=""
                      value={`${String(
                        parseInt(selectedEventForBet?.selectedOdd)
                      )}/${String(
                        parseInt(selectedEventForBet?.selectedRate)
                      )}`}
                      oninput="validity.valid||(value='');"
                      placeholder={0}
                      className="stakeinput input-Betslip text-center"
                      id="betstack11056084_402024910195834877"
                    />
                    {/**/}
                    {/**/}
                    <button
                      onClick={() => {
                        setSelectedEventForBet({
                          ...selectedEventForBet,
                          selectedOdd: parseFloat(
                            parseFloat(selectedEventForBet?.selectedOdd) + 0.01
                          ).toFixed(2),
                        });
                      }}
                      _ngcontent-ng-c1814318807=""
                      className="stakeactionplus btn betButtonPlus float-end"
                    >
                      <span
                        _ngcontent-ng-c1814318807=""
                        className="betButtonPlus"
                      >
                        <svg
                          _ngcontent-ng-c1814318807=""
                          version="1.1"
                          id="Layer_1"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                          x="0px"
                          y="0px"
                          width="19px"
                          height="19px"
                          viewBox="0 0 19 19"
                          enableBackground="new 0 0 19 19"
                          xmlSpace="preserve"
                        >
                          <g _ngcontent-ng-c1814318807="">
                            <path
                              _ngcontent-ng-c1814318807=""
                              fill="currentColor"
                              d="M10.946,0.127v7.964h7.646v2.747h-7.646v8.035h-2.89v-8.035H0.409V8.091h7.647V0.127H10.946z"
                            />
                          </g>
                        </svg>
                      </span>
                    </button>
                  </div>
                  <div
                    _ngcontent-ng-c1814318807=""
                    className="col text-bold inputset p-1 stacksCol"
                  >
                    <button
                      onClick={() => {
                        if (selectedEventForBet?.isCashout) return;
                        if (selectedEventForBet?.amount < 100) return;
                        setSelectedEventForBet({
                          ...selectedEventForBet,
                          amount:
                            selectedEventForBet?.amount -
                            (selectedEventForBet?.amount % 2 == 0
                              ? selectedEventForBet?.amount / 2
                              : selectedEventForBet?.amount),
                        });
                      }}
                      _ngcontent-ng-c1814318807=""
                      className="stakeactionminus btn betButtonMinus"
                    >
                      <span
                        _ngcontent-ng-c1814318807=""
                        className="betButtonMinus"
                      >
                        <svg
                          _ngcontent-ng-c1814318807=""
                          version="1.1"
                          id="Layer_1"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                          x="0px"
                          y="0px"
                          width="19px"
                          height="19px"
                          viewBox="0 0 19 19"
                          enableBackground="new 0 0 19 19"
                          xmlSpace="preserve"
                        >
                          <g _ngcontent-ng-c1814318807="">
                            <path
                              _ngcontent-ng-c1814318807=""
                              fill="currentColor"
                              d="M8.056,10.838H0.409V8.091h7.647 M2,8.091h16.591v2.747H8"
                            />
                          </g>
                        </svg>
                      </span>
                    </button>
                    <input
                      _ngcontent-ng-c1814318807=""
                      type="number"
                      style={isFancy ? { width: "81% " } : {}}
                      value={
                        selectedEventForBet?.amount == 0
                          ? ""
                          : selectedEventForBet?.amount
                      }
                      placeholder={0}
                      disabled={selectedEventForBet?.isCashout}
                      onChange={(e) => {
                        if (selectedEventForBet?.isCashout) return;
                        setSelectedEventForBet({
                          ...selectedEventForBet,
                          amount: e.target.value,
                        });
                      }}
                      className="stakeinput input-Betslip text-center ng-untouched ng-pristine ng-valid"
                      id="betAmount11056084_402024910195834877"
                    />
                    <button
                      onClick={() => {
                        if (selectedEventForBet?.isCashout) return;
                        setSelectedEventForBet({
                          ...selectedEventForBet,
                          amount:
                            selectedEventForBet?.amount +
                            selectedEventForBet?.amount,
                        });
                      }}
                      _ngcontent-ng-c1814318807=""
                      className="stakeactionplus btn betButtonPlus float-end"
                    >
                      <span
                        _ngcontent-ng-c1814318807=""
                        className="betButtonPlus"
                      >
                        <svg
                          _ngcontent-ng-c1814318807=""
                          version="1.1"
                          id="Layer_1"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                          x="0px"
                          y="0px"
                          width="19px"
                          height="19px"
                          viewBox="0 0 19 19"
                          enableBackground="new 0 0 19 19"
                          xmlSpace="preserve"
                        >
                          <g _ngcontent-ng-c1814318807="">
                            <path
                              _ngcontent-ng-c1814318807=""
                              fill="currentColor"
                              d="M10.946,0.127v7.964h7.646v2.747h-7.646v8.035h-2.89v-8.035H0.409V8.091h7.647V0.127H10.946z"
                            />
                          </g>
                        </svg>
                      </span>
                    </button>
                  </div>
                  <div
                    _ngcontent-ng-c1814318807=""
                    onClick={placeBet}
                    className="col p-1 pb-0 hideMobile"
                  >
                    <button
                      disabled={!selectedEventForBet?.amount}
                      _ngcontent-ng-c1814318807=""
                      className="btn btn-send"
                    >
                      {" "}
                      Place Bet{" "}
                    </button>
                  </div>
                </div>
                <div
                  _ngcontent-ng-c1814318807=""
                  className={`row p-2 stackbutton pt-0 pb-0 slip-${selectedEventForBet?.type}-br`}
                >
                  {Object.keys(buttons).map(
                    (item, index) =>
                      item?.startsWith("buttonValue") &&
                      !item?.includes("Casino") && (
                        <div
                          _ngcontent-ng-c1814318807=""
                          className="col-3 col-xs-3 col-sm-3 col-md-3 col-lg-auto col-xl-auto p-1 ng-star-inserted"
                        >
                          <a
                            onClick={() => {
                              if (selectedEventForBet?.isCashout) return;
                              dispatch({
                                type: "gameData/setSelectedEventForBet",
                                payload: {
                                  ...selectedEventForBet,
                                  amount: buttons[item],
                                },
                              });
                            }}
                            _ngcontent-ng-c1814318807=""
                            className="btn btn-block fancy-quick-btn"
                          >
                            {buttons[item]}
                          </a>
                        </div>
                      )
                  )}
                </div>
                <div
                  _ngcontent-ng-c1814318807=""
                  className="row mt-0 p-2 pb-0 pt-0 stackbutton padddingZero hideDesktop"
                >
                  <div _ngcontent-ng-c1814318807="" className="col-6 p-1 pb-0">
                    <a
                      _ngcontent-ng-c1814318807=""
                      onClick={() => {
                        setSelectedEventForBet(null);
                      }}
                      className="btn btn-secondary btn-block btn-cancel"
                    >
                      {" "}
                      Cancel{" "}
                    </a>
                  </div>
                  <div _ngcontent-ng-c1814318807="" className="col-6 p-1 pb-0">
                    <button
                      onClick={placeBet}
                      _ngcontent-ng-c1814318807=""
                      style={{
                        cursor: "pointer",
                        pointerEvents: "auto",
                      }}
                      className="btn btn-send"
                    >
                      {" "}
                      Place Bet{" "}
                    </button>
                    {/**/}
                    {/**/}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </td>
    </tr>
  );
}
